export enum ClientStatus {
    PROSPECT = 'Prospect',
    ACTIVE = 'Active',
    DORMANT = 'Dormant',
    LEAD = 'Lead',
    OTHER = 'Other'
}